import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import Draft, { EditorState, RichUtils } from 'draft-js';
import styled from 'styled-components';
import { headings, blocks, inlineStyles } from './blocks';
import { StyleButton } from './StyleButton';
export var Toolbar = styled.div.withConfig({
  displayName: "EditorControls__Toolbar",
  componentId: "sc-15u6zqs-0"
})(["position:relative;padding-top:30px;"]);
var EditorToolbar = styled.div.withConfig({
  displayName: "EditorControls__EditorToolbar",
  componentId: "sc-15u6zqs-1"
})(["display:flex;flex-wrap:wrap;padding:9px 0 0 9px;border-radius:", ";background:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiLL;
});
var EditorButtons = styled.div.withConfig({
  displayName: "EditorControls__EditorButtons",
  componentId: "sc-15u6zqs-2"
})(["display:flex;border-radius:", ";box-shadow:", ";margin:0 9px 9px 0;background:'#fff';"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.boxShadow;
});
export var EditorControls = function EditorControls(props) {
  var removeLink = function removeLink(event) {
    event && event.preventDefault();
    var editorState = props.editorState,
      onChange = props.onChange;
    var selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      onChange(RichUtils.toggleLink(editorState, selection, null));
    }
  };
  var handleToggleLink = function handleToggleLink() {
    var editorState = props.editorState,
      showLink = props.showLink;
    if (RichUtils.currentBlockContainsLink(editorState)) {
      removeLink();
    } else {
      showLink();
    }
  };
  var insertSign = function insertSign(char) {
    var editorState = props.editorState,
      onChange = props.onChange;
    var contentState = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var newContent;
    if (selection.isCollapsed()) {
      newContent = Draft.Modifier.insertText(contentState, selection, "".concat(char), null, null);
    } else {
      var anchorKey = selection.getAnchorKey();
      var currentContent = editorState.getCurrentContent();
      var currentBlock = currentContent.getBlockForKey(anchorKey);
      var start = selection.getStartOffset();
      var end = selection.getEndOffset();
      var selectedText = currentBlock.getText().slice(start, end);
      newContent = Draft.Modifier.replaceText(contentState, selection, "".concat(char).concat(selectedText), null, null);
    }
    var newEditorState = EditorState.set(editorState, {
      currentContent: newContent
    });
    var editorStateToUpdate = Draft.EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());
    onChange(editorStateToUpdate);
  };
  var insertDollarSign = function insertDollarSign() {
    return insertSign('$');
  };
  var insertAtSign = function insertAtSign() {
    return insertSign('@');
  };
  var editorState = props.editorState,
    onToggleBlockType = props.onToggleBlockType,
    onToggleInlineStyle = props.onToggleInlineStyle,
    showFileDialog = props.showFileDialog,
    showVideoLink = props.showVideoLink;
  var selection = editorState.getSelection();
  var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  var currentStyle = editorState.getCurrentInlineStyle();
  var hasLink;
  try {
    hasLink = RichUtils.currentBlockContainsLink(editorState);
  } catch (err) {
    hasLink = false;
  }
  return React.createElement(EditorToolbar, null, React.createElement(EditorButtons, null, headings.map(function (type) {
    return React.createElement(StyleButton, {
      key: type.label,
      active: type.style === blockType,
      label: type.label,
      icon: type.icon,
      onToggle: onToggleBlockType,
      style: type.style
    });
  })), React.createElement(EditorButtons, null, blocks.map(function (type) {
    return React.createElement(StyleButton, {
      key: type.label,
      active: type.style === blockType,
      label: type.label,
      icon: type.icon,
      onToggle: onToggleBlockType,
      style: type.style
    });
  })), React.createElement(EditorButtons, null, inlineStyles.map(function (type) {
    return React.createElement(StyleButton, {
      key: type.label,
      active: currentStyle.has(type.style),
      label: type.label,
      icon: type.icon,
      onToggle: onToggleInlineStyle,
      style: type.style
    });
  })), React.createElement(EditorButtons, null, React.createElement(StyleButton, {
    key: "link",
    active: hasLink,
    label: "Enlace",
    icon: "link",
    onToggle: handleToggleLink
  }), React.createElement(StyleButton, {
    key: "image",
    active: false,
    label: "Imagen",
    icon: "image",
    onToggle: showFileDialog
  }), React.createElement(StyleButton, {
    key: "video",
    active: false,
    label: "Video",
    icon: "video",
    onToggle: showVideoLink
  })), React.createElement(EditorButtons, null, React.createElement(StyleButton, {
    key: "product",
    active: false,
    label: "Producto",
    icon: "dollar",
    onToggle: insertDollarSign
  }), React.createElement(StyleButton, {
    key: "mention",
    active: false,
    label: "Menci\xF3n",
    icon: "at",
    onToggle: insertAtSign
  })));
};